import React, { useState } from 'react';
import { makeRequest } from "../../../axios";
import './userdb.scss';

const KYCForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    dob: '',
    address: '',
    idNumber: '',
    idFrontImage: null,
    idBackImage: null,
  });
  const [previewFront, setPreviewFront] = useState(null);
  const [previewBack, setPreviewBack] = useState(null);
  const [kycSuccess, setKycSuccess] = useState("");
  const [err, setErr] = useState(null);
  const [phot1, setPhot1] = useState(null)
  const [phot2, setPhot2] = useState(null)

  // Handle text input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle file upload for ID Front
  const handleFrontFileChange = (e) => {
    const file = e.target.files[0];
    // const url = URL.createObjectURL(file)
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Image = reader.result; // Base64 representation of the image
        setPhot1(base64Image);
        setFormData((prevFormData) => ({
          ...prevFormData,
          idFrontImage: base64Image,
        }));
        console.log(base64Image, "front")
      };
      reader.readAsDataURL(file); // Convert the image to Base64
      setPreviewFront(URL.createObjectURL(file));
    }
      
  };

  // Handle file upload for ID Back
  const handleBackFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Image = reader.result; // Base64 representation of the image
        setPhot2(base64Image);
        setFormData((prevFormData) => ({
          ...prevFormData,
          idBackImage: base64Image,
        }));
        console.log(base64Image, "back")
      };
      reader.readAsDataURL(file); // Convert the image to Base64
      setPreviewBack(URL.createObjectURL(file));
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
        e.preventDefault();
    try {
        await makeRequest.post("user-info/kyc", formData);
        setKycSuccess("Upload succesful your details are being processed")
        
        
      } catch (err) {
        setErr(err.response.data);
        console.log(err);
      }
      console.log(previewFront)
    
    alert(`kyc for ${formData.name} has been submitted and is being proccessed`);
    setFormData({
      name: '',
      email: '',
      dob: '',
      address: '',
      idNumber: '',
      idFrontImage: null,
      idBackImage: null,
    });
    setPreviewFront(null);
    setPreviewBack(null);
  };

//   const handleKyc = async (e) => {
//     // e.preventDefault();
//     try {
//       await makeRequest.post("user-info/kyc", formData);
//       setKycSuccess("Upload succesful your details are being processed")
      
      
//     } catch (err) {
//       setErr(err.response.data);
//       console.log(err);
//     }
    
    
//      alert("kyc has been submitted and is being proccessed")
//     //  window.location.reload();
//   }

  console.log(formData)

  return (
    <div className="kyc-form-container">
      <h2>KYC Form</h2>
      <form onSubmit={handleSubmit} className="kyc-form">
        <label htmlFor="name">Name:</label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
          placeholder="Enter your full name"
        />

        <label htmlFor="email">Email:</label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
          placeholder="Enter your email"
        />

        <label htmlFor="dob">Date of Birth:</label>
        <input
          type="date"
          id="dob"
          name="dob"
          value={formData.dob}
          onChange={handleChange}
          required
        />

        <label htmlFor="address">Address:</label>
        <textarea
          id="address"
          name="address"
          value={formData.address}
          onChange={handleChange}
          required
          placeholder="Enter your address"
          rows="3"
        ></textarea>

        <label htmlFor="idNumber">ID Number:</label>
        <input
          type="text"
          id="idNumber"
          name="idNumber"
          value={formData.idNumber}
          onChange={handleChange}
          required
          placeholder="Enter your ID number"
        />

        <label htmlFor="idFrontImage" className="file-label">Upload ID Front:</label>
        <input
          type="file"
          id="idFrontImage"
          name="idFrontImage"
          accept="image/*"
          onChange={handleFrontFileChange}
          required
          className="file-input"
        />
        {previewFront && (
          <div className="preview-container">
            <img src={previewFront} alt="ID Front Preview" className="id-preview" />
          </div>
        )}

        <label htmlFor="idBackImage" className="file-label">Upload ID Back:</label>
        <input
          type="file"
          id="idBackImage"
          name="idBackImage"
          accept="image/*"
          onChange={handleBackFileChange}
          required
          className="file-input"
        />
        {previewBack && (
          <div className="preview-container">
            <img src={previewBack} alt="ID Back Preview" className="id-preview" />
          </div>
        )}

        <button  type="submit">Submit KYC</button>
      </form>
    </div>
  );
};

export default KYCForm;
